import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { environment } from '../../environment/environment';

export interface AppUsageTrackRequest {
  userId: string;
  appId: string;
  appName?: string;
  category?: string;
  subCategory?: string;
}

export interface AppUsageTrackResponse {
  success: boolean;
  message: string;
  usageId: string;
}

export interface MostUsedApp {
  _id: string;
  appliId: string;
  name: string;
  icon: string;
  category: string;
  subCategory: string;
  clickCount: number;
  link: string;
  order: number;
  androidImageUrl?: string;
}

export interface MostUsedAppsResponse {
  userId: string;
  mostUsedApps: MostUsedApp[];
  total: number;
}

@Injectable({
  providedIn: 'root',
})
export class AppUsageService {
  private readonly apiUrl = environment.baseUrl;

  constructor(
    private http: HttpClient,
    private authService: AuthService,
  ) {}

  private getHttpHeaders(): HttpHeaders {
    const token = this.authService.idToken;
    return new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    });
  }

  /**
   * Track app click/usage
   */
  trackAppUsage(data: AppUsageTrackRequest): Observable<AppUsageTrackResponse> {
    return this.http.post<AppUsageTrackResponse>(
      `${this.apiUrl}/app-usage/track`,
      data,
      { headers: this.getHttpHeaders() }
    );
  }

  /**
   * Get most used apps for a user
   */
  getMostUsedApps(
    userId: string,
    limit: number = 10,
    category?: string,
    subCategory?: string
  ): Observable<MostUsedAppsResponse> {
    let url = `${this.apiUrl}/user/${userId}/most-used?limit=${limit}`;
    
    if (category) {
      url += `&category=${encodeURIComponent(category)}`;
    }
    
    if (subCategory) {
      url += `&subCategory=${encodeURIComponent(subCategory)}`;
    }

    return this.http.get<MostUsedAppsResponse>(
      url,
      { headers: this.getHttpHeaders() }
    );
  }
}
